import {
  type PDFLabelSetConstructor,
  type OrderItemLabels,
  type POLabels,
} from '../../entities/PDFLabelSet'
import { type PDFLabelSetApiModel } from '../api-models/PDFLabelSetApiModel'

const mapOrderItemLabels = (orderitem: any): OrderItemLabels => {
  const mappedSourceKeys = new Set<string>()

  const mapAndTrackKeys = (key: string) => {
    mappedSourceKeys.add(key)
    return orderitem[key]
  }

  const mappedLabels: any = {
    itemDescription: mapAndTrackKeys('Item Description'),
    totalPrice: mapAndTrackKeys('Total Price'),
    poNote: mapAndTrackKeys('po_note'),
    price: mapAndTrackKeys('price'),
    quantity: mapAndTrackKeys('quantity'),
    sku: mapAndTrackKeys('sku'),
    unit: mapAndTrackKeys('unit'),
  }

  Object.keys(orderitem).forEach((key) => {
    if (!mappedSourceKeys.has(key)) {
      mappedLabels[key] = orderitem[key]
    }
  })

  return mappedLabels
}

const mapPOLabels = (po: any): POLabels => {
  const mappedSourceKeys = new Set<string>()

  const mapAndTrackKeys = (key: string) => {
    mappedSourceKeys.add(key)
    return po[key]
  }

  const mappedLabels: any = {
    poNumber: mapAndTrackKeys('PO_Number'),
    purchaseOrder: mapAndTrackKeys('Purchase Order'),
    shipTo: mapAndTrackKeys('Ship To'),
    comment: mapAndTrackKeys('comment'),
    creditcard: mapAndTrackKeys('creditcard'),
    date: mapAndTrackKeys('date'),
    discount: mapAndTrackKeys('discount'),
    freight: mapAndTrackKeys('freight'),
    other: mapAndTrackKeys('other'),
    paymentTerms: mapAndTrackKeys('payment_terms'),
    prefVendor: mapAndTrackKeys('pref_vendor'),
    promiseDate: mapAndTrackKeys('promise_date'),
    shippingMethod: mapAndTrackKeys('shipping_method'),
    shippingTerms: mapAndTrackKeys('shipping_terms'),
    subtotal: mapAndTrackKeys('subtotal'),
    tax: mapAndTrackKeys('tax'),
    total: mapAndTrackKeys('total'),
  }

  Object.keys(po).forEach((key) => {
    if (!mappedSourceKeys.has(key)) {
      mappedLabels[key] = po[key]
    }
  })

  return mappedLabels
}

export const mapPDFLabelSetApiModel = (
  data: PDFLabelSetApiModel
): PDFLabelSetConstructor => ({
  isPrimary: data.is_primary,
  key: data.key,
  value: {
    name: data.value.name,
    orderitem: mapOrderItemLabels(data.value.orderitem),
    po: mapPOLabels(data.value.po),
  },
})
